import { store } from '@store';

import { userService } from './userService';
import { PracticeApi } from '@api/PracticeApi';
import { getIds } from '@utils/getIds';

class UserAssistantService {
    // Remove if not needed by autumn 2025
    public async loadUserPracticeDoctors(userId: string): Promise<void> {
        const [doctors] = await Promise.all([
            PracticeApi.getUserDoctorList(userId),
            userService.loadIfNotExist([userId]),
        ]);

        const user = store.userList.getExisting(userId);
        const ids = getIds(doctors);
        user.setPracticeDoctorsIds(ids);

        await userService.loadIfNotExist(getIds(doctors));

        if (userId === store.authUser.id) {
            store.authUser.setPracticeDoctorsIds(ids);
        }
    }
}

export const userAssistantService = new UserAssistantService();
